import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const TermsAndConditions = () => {

    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top when component is mounted
    }, []);
  return (
    <Container>
      <div class="privacy_text">
        <h2>SparkPro Terms and Conditions </h2>
        <h4>
          <b>Last Updated :</b> 26 February 2025{" "}
        </h4>
        <p>
          Welcome to SparkPro, the UK’s dedicated platform for hiring trusted
          electricians. These Terms and Conditions govern your use of SparkPro,
          so please read them carefully. By signing up, accessing, or using the
          platform, you agree to comply with these Terms. If you do not agree,
          you must not use SparkPro.
        </p>

        <h4>1. About SparkPro</h4>
        <p>
          1.1 SparkPro is an online platform connecting customers with
          electricians for electrical work.{" "}
        </p>
        <p>
          1.2 SparkPro does not provide electrical services, manage payments
          between users, or guarantee job opportunities.
        </p>

        <h4>2. Eligibility </h4>
        <p>2.1 To use SparkPro as an electrician, you must: </p>
        <ul>
          <li>Be at least 18 years old.</li>
          <li>
            Hold the necessary qualiﬁcations and insurance to perform electrical
            work in the UK.
          </li>
          <li>
            Provide accurate and up-to-date information during registration.
          </li>
        </ul>
        <p>
          2.2 SparkPro reserves the right to verify credentials but does not
          guarantee or certify electricians’ qualiﬁcations.
        </p>

        <h4>3. Account Registration & Responsibilities</h4>

        <p>
          3.1 You must provide accurate information when registering and keep
          your details updated.{" "}
        </p>
        <p>
          3.2 You are responsible for securing your login credentials. SparkPro
          is not liable for unauthorised access to your account.
        </p>
        <p>
          3.3 Accounts are non-transferable. You may not share or sell your
          account.
        </p>

        <h4>4. Subscription & Pricing</h4>

        <p>
          4.1 <b>Free Trial: </b> Electricians receive a
          <b>3-month free trial </b>, which includes <b>5 quotes per month </b>.
        </p>
        <p>4.2 After the trial, electricians can subscribe to:</p>
        <ul>
          <li>
            {" "}
            <b>Standard Plan:</b> £80/month for <b>10 quotes per month</b>.
          </li>
          <li>
            <b>Premium Plan:</b> £120/month for <b>20 quotes per month</b>, a
            highlighted proﬁle, and increased recommendations
          </li>
        </ul>

        <p>4.3 Additional quotes can be purchased separately:</p>
        <ul>
          <li>
            <b>10 quotes:</b> £90
          </li>
          <li>
            <b>20 quotes:</b> £130{" "}
          </li>
          <li>
            <b>50 quotes: </b> £180
          </li>
        </ul>
        <p>
          4.4 All subscription fees are charged monthly and are 
          <b>non-refundable</b>.
        </p>
        <p>
          4.5 You can cancel your subscription at any time, but no refunds will
          be provided for unused time.{" "}
        </p>

        <h4>5. Job Opportunities & Quote System</h4>
        <p>
          5.1 SparkPro provides job quotes based on your subscription or
          purchased credits.
        </p>
        <p>
          5.2 Receiving a lead does not guarantee securing a job. Customers
          decide which electrician to hire.
        </p>
        <p>
          5.3 SparkPro does not inﬂuence customer decisions and is not
          responsible for job outcomes.
        </p>

        <h4>6. Veriﬁcation & Proﬁle Visibility</h4>
        <p>
          6.1 Electricians can apply for veriﬁcation to enhance proﬁle
          visibility.
        </p>
        <p>
          6.2 Veriﬁcation involves credential checks but is not an endorsement
          or certiﬁcation by SparkPro
        </p>
        <p>
          6.3 SparkPro may revoke veriﬁcation if any provided information is
          found to be false or outdated
        </p>

        <h4>7. Customer Interactions & Responsibilities</h4>
        <p>
          7.1 Electricians are responsible for assessing job details and
          conducting their own due diligence.
        </p>
        <p>
          7.2 SparkPro does not mediate disputes between customers and
          electricians.
        </p>
        <p>
          7.3 All work performed must comply with UK laws, safety regulations,
          and industry standards.
        </p>
        <h4>8. Payments & Fees</h4>
        <p>
          8.1 SparkPro does not manage payments between customers and
          electricians.
        </p>
        <p>
          8.2 Electricians and customers must arrange payments independently.
        </p>
        <p>
          8.3 SparkPro is not responsible for payment disputes, non-payment, or
          failed transactions.
        </p>

        <h4>9. Prohibited Conduct</h4>
        <p>You agree not to:</p>
        <ul>
          <li> Provide false, misleading, or incomplete information. </li>
          <li> Use SparkPro for any unlawful or unethical purposes. </li>
          <li> Attempt to manipulate reviews or ratings. </li>
          <li> Engage in fraudulent, abusive, or offensive behaviour. </li>
          <li>
            {" "}
            Use multiple accounts to bypass limitations or gain an unfair
            advantage.
          </li>
        </ul>

        <h4>10. Account Suspension & Termination</h4>
        <p>
          10.1 SparkPro reserves the right to suspend or terminate accounts that
          violate these Terms.
        </p>
        <p>
          10.2 Terminated accounts due to violations will not receive refunds.
        </p>

        <h4>11. Liability & Disclaimers</h4>

        <p>
          11.1 SparkPro provides a connection platform but does not guarantee
          the quality, reliability, or outcomes of any job.
        </p>
        <p>
          11.2 SparkPro is not liable for any damages, losses, or disputes
          arising from platform use.
        </p>
        <p>
          11.3 Users assume full responsibility for their interactions and
          transactions.{" "}
        </p>
        <h4>12. Changes to Terms</h4>
        <p>12.1 SparkPro may update these Terms at any time.</p>
        <p>
          12.2 Continued use of the platform after updates constitutes
          acceptance of the new Terms.{" "}
        </p>
        <h4>13. Governing Law </h4>
        <p>13.1 These Terms are governed by the laws of the United Kingdom. </p>
        <p>13.2 Any disputes will be resolved under UK jurisdiction. </p>
        <h4>14. Contact Us </h4>

        <p>
          For any questions or concerns, contact us at{" "}
          <a href="/ contact@sparkpro.app "> contact@sparkpro.app </a>{" "}
        </p>
      </div>
    </Container>
  );
};

export default TermsAndConditions;
